import React from 'react';
import { Box, Stack, Typography, CircularProgress, Link } from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListItem } from 'website/components/BlogListItem';
import { IconWrapper } from 'components/Icon';
import { useGetRelatedBlogsBySlug } from '../api/getRelatedBlogsBySlug';

export const RecentBlogs = ({ slug  }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { data, isLoading, isError, error } = useGetRelatedBlogsBySlug(slug, {
    page: 0,
    limit: 1, // Fetching 1 recent blog
    queryOptions: {
      enabled: !!slug,
    },
  });

  const blogs = data?.blogs;
  const seeAllLink = `${location.pathname}?tab=blog`;

  // Only render the section if:
  // 1. slug is present
  // 2. Not in an error state
  // 3. Not currently loading AND there are no blogs OR currently loading BUT there are already some blogs to show.
  if (!slug || isError || (!isLoading && (!blogs || blogs.length === 0))) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 3,
        border: '1px solid',
        borderRadius: '8px',
        backgroundColor: 'background.paper',
        borderColor: 'grey.100'
      }}
    >
      {isLoading && <CircularProgress size={20} sx={{ ml: 1 }} />}
      <Stack spacing={2}>
        {blogs && blogs.map(blog => ( // Only map if blogs exist
          <ListItem key={blog.blog_id} {...blog} forcePublicUrls={false} />
        ))}
        <Box>
          <Link
            component={RouterLink}
            to={seeAllLink}
            color="primary.light"
          >
            <Stack sx={{justifyContent: "flex-end", flexDirection: "row", gap: 1}}>
              <Typography>{t('website:publicProfile.seeAll')}</Typography>
              <IconWrapper
                icon="arrowRightLong"
                sx={({ palette }) => ({
                  svg: {
                    color: palette.primary.light,
                    stroke: palette.primary.light,
                    width: 20,
                    height: 20,
                  },
                })}
              />
            </Stack>
          </Link>
        </Box>
      </Stack>
    </Box>
  );
};
